import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import {
  ActiveSubscriptionsKpiResponse,
  CertificationUserCount,
  OrganizationsResponse,
  OrganizationsSummaryResponse,
  WebinarsSummaryResponseEntry,
} from 'types/admin/analytics';

export class AnalyticsService {
  constructor(private axiosInstance: AxiosInstance) {}

  getCertificationUserCounts = async (): Promise<CertificationUserCount[]> => {
    const response = await this.axiosInstance.get<Result<CertificationUserCount[]>>('/api/admin/analytics/certifications/user-counts');
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching certification user counts.');
  };

  getOrganizations = async (): Promise<OrganizationsResponse[]> => {
    const response = await this.axiosInstance.get<Result<OrganizationsResponse[]>>('/api/admin/analytics/organizations');
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching organizations.');
  };

  getStudentsCount = async (): Promise<number> => {
    const response = await this.axiosInstance.get<Result<number>>('/api/admin/analytics/students-count');
    if (response.data && !response.data.isError && response.data.data !== undefined) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching students count.');
  };

  getOrganizationsSummary = async (): Promise<OrganizationsSummaryResponse[]> => {
    const response = await this.axiosInstance.get<Result<OrganizationsSummaryResponse[]>>('/api/admin/analytics/organizations');
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching organizations summary.');
  };

  getWebinarsSummary = async (): Promise<WebinarsSummaryResponseEntry[]> => {
    const response = await this.axiosInstance.get<Result<WebinarsSummaryResponseEntry[]>>('/api/admin/analytics/webinars/snapshots');
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching webinars summary.');
  };
  getActiveSubscriptionsKpi = async (): Promise<ActiveSubscriptionsKpiResponse> => {
    const response = await this.axiosInstance.get<Result<ActiveSubscriptionsKpiResponse>>('/api/admin/analytics/subscribers/active-kpi');
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching active subscriptions KPI.');
  };
}
